import { XpressDisciplinaryReasonsEnum } from 'app/models';

export class XpressDisciplinaryReasonsModel {
    public static XpressDisciplinaryReasonsList: Array<any> = [
        { name: 'Insufficient Evidence', value: XpressDisciplinaryReasonsEnum.InsufficientEvidence },
        { name: 'Cannot contact customer', value: XpressDisciplinaryReasonsEnum.CannotContactCustomer },
        { name: 'Driver not at fault', value: XpressDisciplinaryReasonsEnum.DriverNotAtFault }
    ];
}
